// src/pages/Homepage/FAQHomepage.tsx
import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Container,
  Paper,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { motion } from 'framer-motion';

const faqList = [
  {
    question: 'Como me inscrever em um curso?',
    answer: (
      <>
        <strong>Opção 1 – Pelo site:</strong>
        <ul>
          <li>
            <strong>Curso de Graduação:</strong> Acesse <em>Cursos &gt; Cursos
            de Graduação</em>, escolha o curso de interesse e clique em{' '}
            <em>Mais Informações</em> e depois em <em>Inscrição</em> para a
            unidade desejada.
          </li>
          <li>
            <strong>Curso de Pós-graduação:</strong> Acesse <em>Cursos &gt;
            Pós-graduação</em>, escolha o curso e clique em{' '}
            <em>Mais Informações</em> &gt; <em>Registrar Interesse</em>. A
            equipe entrará em contato com você.
          </li>
          <li>
            <strong>Curso de Extensão Universitária:</strong> Acesse <em>Cursos
            &gt; Extensão Universitária</em>, escolha o curso e clique em{' '}
            <em>Mais Informações</em> &gt; <em>Inscrição</em> para a unidade de
            interesse.
          </li>
        </ul>

        <strong>Opção 2 – Presencialmente nas unidades da Faculdade de Tecnologia Senac Amazonas:</strong>
        <ul>
          <li>
            <strong>Faculdade Senac:</strong> Rua 10 de Julho Nº 11 – Centro<br />
            <em>Atendimento:</em> Segunda a Sexta, 09h00 às 17h00
          </li>
          <li>
            <strong>Faculdade Senac Centro:</strong> Rua Saldanha Marinho Nº 410 – Centro<br />
            <em>Atendimento:</em> Segunda a Sexta, 17h00 às 21h00
          </li>
          <li>
            <strong>Centro de Informática:</strong> Rua Darcy Vargas Nº 288 – Chapada<br />
            <em>Atendimento:</em> Segunda a Sexta, 17h00 às 21h00
          </li>
        </ul>
      </>
    ),
  },
  {
    question: 'Quais documentos são necessários para matrícula?',
    answer: (
      <>
        <p>
          Para efetuar sua matrícula, é necessário apresentar os seguintes
          documentos (originais e cópias):
        </p>
        <p>📄 <strong>Documentos pessoais:</strong></p>
        <ul>
          <li>RG (Carteira de Identidade) ou, no caso de estrangeiro, RNM/Passaporte;</li>
          <li>CPF (Cadastro de Pessoa Física);</li>
          <li>Certidão de Nascimento ou Casamento.</li>
        </ul>

        <p>🏫 <strong>Documentos escolares:</strong></p>
        <ul>
          <li>Histórico Escolar do Ensino Médio;</li>
          <li>Certificado de Conclusão do Ensino Médio.</li>
        </ul>

        <p>🏠 <strong>Comprovante de residência atualizado:</strong></p>
        <ul>
          <li>Conta de água, luz ou telefone recente.</li>
        </ul>
      </>
    ),
  },
  {
    question: 'Como entrar em contato com a secretaria?',
    answer: (
      <>
        <p>✉️ <strong>E-mail:</strong> secretaria.faculdade@am.senac.br</p>
        <p>📱 <strong>Telefone:</strong> (92) 3199-9956</p>
      </>
    ),
  },
];


const FAQHomepage: React.FC = () => {
  return (
    <Box
      component="section"
      sx={{
        background: 'linear-gradient(135deg, #2d0b5e, #842569)',
        color: '#fff',
        py: 10,
        px: '5%',
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <Paper elevation={3} sx={{ borderRadius: 3, p: 3 }}>
            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{
                fontFamily: 'Playfair Display, serif',
                fontWeight: 600,
                color: 'primary.main',
                textAlign: 'center',
                mb: 3,
              }}
            >
              Dúvidas Frequentes
            </Typography>

            {faqList.map((item, index) => (
              <Accordion
                key={index}
                disableGutters
                sx={{
                  mb: 1,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    borderBottom: '2px solid #842569',
                  },
                  '& .MuiAccordionSummary-root': {
                    transition: 'background 0.2s ease',
                  },
                }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      fontWeight: 600,
                    }}
                  >
                    <HelpOutlineIcon color="primary" fontSize="small" />
                    {item.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2" sx={{ color: '#333' }}>
                    {item.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default FAQHomepage;
